export const constants = {
  CURRENT_PAGE: "current_page",
  ANSWERS: "answers",
  SCORE: "score",
  RESULTS: "results",
};
